module.exports = __webpack_public_path__ + "static/media/googlereviews.29884693.png";